export function parseEnum<T extends string>(value: string, enumObject: Record<string, T>): T {
  if (!Object.values(enumObject).includes(value as T)) {
    console.error(`Unknown enum value: "${value}"`);
    throw new Error(`Unknown enum value: "${value}"`);
  }

  return value as T;
}

export function tryParseEnum<T extends string>(value: string, enumObject: Record<string, T>): T | undefined {
  return Object.values(enumObject).includes(value as T) ? (value as T) : undefined;
}
